import { render, staticRenderFns } from "./lottie.vue?vue&type=template&id=66d58f46&"
import script from "./lottie.vue?vue&type=script&lang=js&"
export * from "./lottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports